import showdown from 'showdown';

/* @ngInject */
export default function ($scope, AuthService, $timeout, LayoutService, $stateParams, toastr, TrainingModules, $state, moment, TrainingAttempts, PreferencesService) {
	$scope.courseId       = $stateParams.courseId;
	$scope.userId         = $stateParams.userId;
	$scope.attemptId      = $stateParams.attemptId;
	$scope.loading        = true;
	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.parseMarkdown = (markdown) => {
		let converter = new showdown.Converter();

		return converter.makeHtml(markdown);
	};

	$scope.refresh = () => {
		$scope.loading = true;

		TrainingAttempts.one($scope.attemptId)
		                .get({
			                include: 'module.course,items.item,user.workable',
		                })
		                .then((attempt) => {
			                $scope.attempt = attempt;

			                if ($scope.attempt.items && $scope.attempt.items.length > 0) {
				                $scope.attempt.items.sort((a, b) => {
					                return a.sort - b.sort;
				                });
			                }

			                $scope.updateLayout($scope.attempt.module.course.name, $scope.attempt.user.workable.name, $scope.attempt.module.title);

			                $scope.loading = false;
		                })
		                .catch((error) => {
			                toastr.clear();
			                toastr.error('There was an error while loading this attempt, please try again.', 'Error');

			                $state.go('staff.training.results.users.view', {
				                courseId: $scope.courseId,
				                userId:   $scope.userId,
			                });

			                $scope.loading = false;
		                });
	};

	$scope.updateLayout = (courseName = 'Loading...', userName = 'Loading...', moduleName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			moduleName,
			userName,
			courseName,
			'Results',
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setSubtitle(courseName);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       'staff.training.results.root',
				             displayName: 'Results',
			             },
			             {
				             route:       `staff.training.results.view({ courseId: "${$scope.courseId}" })`,
				             displayName: courseName,
			             },
			             {
				             route:       `staff.training.results.users.view({ courseId: "${$scope.courseId}", userId: "${$scope.userId}" })`,
				             displayName: userName,
			             },
			             {
				             route:       `staff.training.results.users.attempts.view({ courseId: "${$scope.courseId}", userId: "${$scope.userId}", attemptId: "${$scope.attemptId}" })`,
				             displayName: moduleName,
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		LayoutService.getPageHeader()
		             .onClicked(() => {
			             $scope.refresh();
		             });
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/results/users/attempts/view/controller.js